"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeBlobFromString = exports.base64StringDecode = exports.base64StringEncode = exports.fileToBase64 = void 0;

/**
 * Encode file to base64.
 *
 * @param {Blob} file
 * @returns {Promise<string>}
 */
var fileToBase64 = function fileToBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      return resolve(reader.result);
    };

    reader.onerror = function (error) {
      return reject(error);
    };
  });
};

exports.fileToBase64 = fileToBase64;

var base64StringEncode = function base64StringEncode(input) {
  return btoa(encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode(parseInt("0x".concat(p1), 16));
  }));
};

exports.base64StringEncode = base64StringEncode;

var base64StringDecode = function base64StringDecode(input) {
  return decodeURIComponent(atob(input).split('').map(function (_char) {
    return "%".concat("00".concat(_char.charCodeAt(0).toString(16)).slice(-2));
  }).join(''));
};
/**
 * Function to transform a string into a blob avoiding use fetch() method.
 *
 * @param {string} fileData
 * @returns {Blob}
 */


exports.base64StringDecode = base64StringDecode;

var makeBlobFromString = function makeBlobFromString(fileData) {
  var base64Marker = ';base64,';
  var chunks = fileData.split(base64Marker);
  var contentType = chunks[0].split(':')[1];
  var rawImageData = window.atob(chunks[1]);
  var rawLength = rawImageData.length;
  var uInt8ArrayInfo = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; i += 1) {
    uInt8ArrayInfo[i] = rawImageData.charCodeAt(i);
  }

  return new Blob([uInt8ArrayInfo], {
    type: contentType
  });
};

exports.makeBlobFromString = makeBlobFromString;